import {jsonArrayMember, jsonMember, jsonObject} from "typedjson";
import {PitActivity} from "./pit-activity";
import {PitActivityFinancingAmount} from "./pit-activity-financing-amount";
import {PitActivityStateProgramIndicators} from "./pit-activity-state-program-indicators";
import {PitFile} from "../../pit-shared/domain/pit-file";
import {PitFinancingRedistribution} from "./pit-financing-redistribution";
import {IPitFinancingRedistributionLite, PitFinancingRedistributionLite} from "./pit-financing-redistribution-lite";
import {PitActivityFinancingAmountBySource} from "./pit-activity-financing-amount-by-source";
import {PitBpmProcessInstance} from "../../pit-shared/domain/pit-bpm-process-instance";
import {DxObjectMapper} from "../../dx-core/services/dx-object-mapper.service";


/** Версия мероприятия */
@jsonObject
export class PitActivityVersion {
  /** ID версии мероприятия **/
  @jsonMember({name: "id", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _id: number;

  /** Код версии мероприятия. **/
  @jsonMember({name: "code", constructor: String, emitDefaultValue: false, isRequired: false })
  private _code: string;

  /** Общие реквизиты мероприятия */
  @jsonMember({name: "activity", constructor: PitActivity, emitDefaultValue: false, isRequired: false })
  private _activity: PitActivity = new PitActivity();

  /** Актуальная версия или нет */
  @jsonMember({name: "isActual", constructor: Boolean, emitDefaultValue: false, isRequired: false})
  private _isActual: boolean;

  /** Дата актуальности */
  @jsonMember({name: "actualDate", constructor: Date, emitDefaultValue: false, isRequired: false})
  private _actualDate: Date;

  /** Версия удалена */
  @jsonMember({name: "isDeleted", constructor: Boolean, emitDefaultValue: false, isRequired: false})
  private _isDeleted: boolean;

  /** Функциональный заказчик */
  @jsonMember({name: "funcCustomerId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _funcCustomerId: number;

  /** Государственный заказчик */
  @jsonMember({name: "govCustomerId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _govCustomerId: number;

  /** Государственная программа */
  @jsonMember({name: "stateProgramId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _stateProgramId: number;

  /** Блок */
  @jsonMember({name: "blockId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _blockId: number;

  /** Подблок */
  @jsonMember({name: "subBlockId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _subBlockId: number;

  /** ДопЭК */
  @jsonMember({name: "dopEkId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _dopEkId: number;

  /** КЦСР */
  @jsonMember({name: "kcsrId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _kcsrId: number;

  /** Статус версии мероприятия */
  @jsonMember({name: "statusId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _statusId: number;

  /** Тип плана мероприятия */
  @jsonMember({name: "planTypeId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _planTypeId: number;

  /** Плановая дата объявления закупки */
  @jsonMember({name: "purchaseStartPlanDate", constructor: Date, emitDefaultValue: false, isRequired: false})
  private _purchaseStartPlanDate: Date;

  /** Дата последнего изменения */
  @jsonMember({name: "changeDate", constructor: Date, emitDefaultValue: false, isRequired: false})
  private _changeDate: Date;

  /** Автор последнего изменения */
  @jsonMember({name: "changeUserFio", constructor: String, emitDefaultValue: false, isRequired: false })
  private _changeUserFio: string;

  /** Комментарий при последнем изменении */
  @jsonMember({name: "changeNotice", constructor: String, emitDefaultValue: false, isRequired: false })
  private _changeNotice: string;

  /** Бюджетный период */
  @jsonMember({name: "budgetPeriod", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _budgetPeriod: number;

  /** Тип работ */
  @jsonMember({name: "workTypeId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _workTypeId: number;

  /** Итого по всем периодам **/
  @jsonMember({name: "totalAmount", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _totalAmount: number;

  /** Сумма за первый отчетный период. **/
  @jsonMember({name: "firstPeriodAmount", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _firstPeriodAmount: number;

  /** Сумма за второй отчетный период. **/
  @jsonMember({name: "secondPeriodAmount", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _secondPeriodAmount: number;

  /** Сумма за третий отчетный период. **/
  @jsonMember({name: "thirdPeriodAmount", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _thirdPeriodAmount: number;

  /** Итого по всем периодам (региональный бюджет) **/
  @jsonMember({name: "totalRegionalAmount", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _totalRegionalAmount: number;

  /** Сумма за первый отчетный период (региональный бюджет) **/
  @jsonMember({name: "firstPeriodRegionalAmount", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _firstPeriodRegionalAmount: number;

  /** Сумма за второй отчетный период (региональный бюджет) **/
  @jsonMember({name: "secondPeriodRegionalAmount", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _secondPeriodRegionalAmount: number;

  /** Сумма за третий отчетный период (региональный бюджет) **/
  @jsonMember({name: "thirdPeriodRegionalAmount", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _thirdPeriodRegionalAmount: number;

  /** Финансирование по годам */
  @jsonArrayMember(PitActivityFinancingAmount, {name: "financingAmount", emitDefaultValue: false, isRequired: false})
  private _financingAmount: PitActivityFinancingAmount[];

  /** Финансирование по источникам */
  @jsonArrayMember(PitActivityFinancingAmountBySource, {name: "financingAmountBySources", emitDefaultValue: false, preserveNull: false, isRequired: false})
  private _financingAmountBySource: PitActivityFinancingAmountBySource[] = [];

  /** Перераспределение по источникам */
  @jsonArrayMember(PitFinancingRedistribution, {name: "financingRedistribution", emitDefaultValue: false, preserveNull: false, isRequired: false})
  private _financingRedistribution: PitFinancingRedistribution[] = [];

  @jsonArrayMember(PitFinancingRedistributionLite, {name: "financingRedistributionLight", emitDefaultValue: false, isRequired: false})
  get financingRedistributionLight(): PitFinancingRedistributionLite[] {
    return this.financingRedistribution ?
      DxObjectMapper.deserializeASArray(DxObjectMapper.serializeASArray(this.financingRedistribution, PitFinancingRedistribution), PitFinancingRedistributionLite) : [];
  }

  /** Показатели государственной программы */
  @jsonArrayMember(PitActivityStateProgramIndicators, {name: "stateProgramIndicators", emitDefaultValue: false, isRequired: false})
  private _stateProgramIndicators: PitActivityStateProgramIndicators[];

  /** Массив прикрепленных файлов */
  @jsonArrayMember(PitFile, {emitDefaultValue: false, isRequired: false})
  files: PitFile[] = [];

  /**
   * опциональное поле
   */
  processInstance: PitBpmProcessInstance;



  get id(): number {
    return this._id;
  }

  set id(value: number) {
    this._id = value;
  }

  get code(): string {
    return this._code;
  }

  set code(value: string) {
    this._code = value;
  }

  get activity(): PitActivity {
    return this._activity;
  }

  set activity(value: PitActivity) {
    this._activity = value;
  }

  get isActual(): boolean {
    return this._isActual;
  }

  set isActual(value: boolean) {
    this._isActual = value;
  }

  get actualDate(): Date {
    return this._actualDate;
  }

  set actualDate(value: Date) {
    this._actualDate = value;
  }

  get isDeleted(): boolean {
    return this._isDeleted;
  }

  set isDeleted(value: boolean) {
    this._isDeleted = value;
  }

  get funcCustomerId(): number {
    return this._funcCustomerId;
  }

  set funcCustomerId(value: number) {
    this._funcCustomerId = value;
  }

  get govCustomerId(): number {
    return this._govCustomerId;
  }

  set govCustomerId(value: number) {
    this._govCustomerId = value;
  }

  get stateProgramId(): number {
    return this._stateProgramId;
  }

  set stateProgramId(value: number) {
    this._stateProgramId = value;
  }

  get blockId(): number {
    return this._blockId;
  }

  set blockId(value: number) {
    this._blockId = value;
  }

  get subBlockId(): number {
    return this._subBlockId;
  }

  set subBlockId(value: number) {
    this._subBlockId = value;
  }

  get dopEkId(): number {
    return this._dopEkId;
  }

  set dopEkId(value: number) {
    this._dopEkId = value;
  }

  get kcsrId(): number {
    return this._kcsrId;
  }

  set kcsrId(value: number) {
    this._kcsrId = value;
  }

  get statusId(): number {
    return this._statusId;
  }

  set statusId(value: number) {
    this._statusId = value;
  }

  get purchaseStartPlanDate(): Date {
    return this._purchaseStartPlanDate;
  }

  set purchaseStartPlanDate(value: Date) {
    this._purchaseStartPlanDate = value;
  }

  get changeDate(): Date {
    return this._changeDate;
  }

  set changeDate(value: Date) {
    this._changeDate = value;
  }

  get changeUserFio(): string {
    return this._changeUserFio;
  }

  set changeUserFio(value: string) {
    this._changeUserFio = value;
  }

  get changeNotice(): string {
    return this._changeNotice;
  }

  set changeNotice(value: string) {
    this._changeNotice = value;
  }

  get financingAmount(): PitActivityFinancingAmount[] {
    return this._financingAmount;
  }

  set financingAmount(value: PitActivityFinancingAmount[]) {
    this._financingAmount = value;
  }

  get financingAmountBySource(): PitActivityFinancingAmountBySource[] {
    return this._financingAmountBySource;
  }

  set financingAmountBySource(value: PitActivityFinancingAmountBySource[]) {
    this._financingAmountBySource = value;
  }

  get stateProgramIndicators(): PitActivityStateProgramIndicators[] {
    return this._stateProgramIndicators;
  }

  set stateProgramIndicators(value: PitActivityStateProgramIndicators[]) {
    this._stateProgramIndicators = value;
  }

  get planTypeId(): number {
    return this._planTypeId;
  }

  set planTypeId(value: number) {
    this._planTypeId = value;
  }

  get budgetPeriod(): number {
    return this._budgetPeriod;
  }

  set budgetPeriod(value: number) {
    this._budgetPeriod = value;
  }

  get workTypeId(): number {
    return this._workTypeId;
  }

  set workTypeId(value: number) {
    this._workTypeId = value;
  }

  get totalAmount(): number {
    return this._totalAmount;
  }

  set totalAmount(value: number) {
    this._totalAmount = value;
  }

  get firstPeriodAmount(): number {
    return this._firstPeriodAmount;
  }

  set firstPeriodAmount(value: number) {
    this._firstPeriodAmount = value;
  }

  get secondPeriodAmount(): number {
    return this._secondPeriodAmount;
  }

  set secondPeriodAmount(value: number) {
    this._secondPeriodAmount = value;
  }

  get thirdPeriodAmount(): number {
    return this._thirdPeriodAmount;
  }

  set thirdPeriodAmount(value: number) {
    this._thirdPeriodAmount = value;
  }

  get totalRegionalAmount(): number {
    return this._totalRegionalAmount;
  }

  set totalRegionalAmount(value: number) {
    this._totalRegionalAmount = value;
  }

  get firstPeriodRegionalAmount(): number {
    return this._firstPeriodRegionalAmount;
  }

  set firstPeriodRegionalAmount(value: number) {
    this._firstPeriodRegionalAmount = value;
  }

  get secondPeriodRegionalAmount(): number {
    return this._secondPeriodRegionalAmount;
  }

  set secondPeriodRegionalAmount(value: number) {
    this._secondPeriodRegionalAmount = value;
  }

  get thirdPeriodRegionalAmount(): number {
    return this._thirdPeriodRegionalAmount;
  }

  set thirdPeriodRegionalAmount(value: number) {
    this._thirdPeriodRegionalAmount = value;
  }

  get financingRedistribution(): PitFinancingRedistribution[] {
    return this._financingRedistribution;
  }

  set financingRedistribution(value: PitFinancingRedistribution[]) {
    this._financingRedistribution = value;
  }

}
